(function(){
  document.querySelectorAll('.pff-rail').forEach(function(sec){
    if(sec.dataset.ready)return;sec.dataset.ready=1;
    var t=sec.querySelector('[data-pff-rail]');if(!t)return;
    var tabs=sec.querySelectorAll('.pff-tabs button'),lnk=sec.querySelector('.pff-rail-ctrl .pff-link');
    tabs.forEach(function(tb){tb.addEventListener('click',function(){tabs.forEach(function(x){x.classList.toggle('is-on',x===tb);x.setAttribute('aria-selected',x===tb);});
      sec.querySelectorAll('[data-pff-rail]').forEach(function(tr){tr.hidden=tr.dataset.tab!==tb.dataset.t;});t=sec.querySelector('[data-pff-rail]:not([hidden])');
      if(lnk){lnk.href=tb.dataset.url;lnk.textContent=tb.dataset.l;}t.addEventListener('scroll',function(){window.requestAnimationFrame(upd)},{passive:true});upd();});});
    var btns=sec.querySelectorAll('.pff-arrow');
    function upd(){if(!btns.length)return;btns[0].disabled=t.scrollLeft<4;btns[1].disabled=t.scrollLeft+t.clientWidth>=t.scrollWidth-4;}
    btns.forEach(function(b){b.addEventListener('click',function(){t.scrollBy({left:(+b.dataset.dir)*t.clientWidth*0.9,behavior:'smooth'});});});
    t.addEventListener('scroll',function(){window.requestAnimationFrame(upd)},{passive:true});upd();
  });
})();
